import React from 'react'
import { Link } from 'react-router-dom';
import { IconType } from 'react-icons';
import './menuitem.css';

interface Props {
    icon?    : IconType;
    to?      : string;
    children : string;
    onSelect : () => void;
}

export class MenuItem extends React.Component<Props> {

    handleClick()
    {
        this.props.onSelect();
    }

    render() {
        return (
            <li className="menu-item">
                <div className="menu-items">
                { this.props.icon && ( React.createElement(this.props.icon as React.ComponentType) ) }

                { (this.props.to ? 
                    (<Link to={this.props.to} onClick={ () => this.handleClick() }><span className="menu-item-desc">{ this.props.children }</span></Link>)
                    : (<button onClick={() => this.handleClick() }><span className="menu-item-desc"> { this.props.children } </span></button>)
                )}
                </div>
            </li>
        );
    }
}

